import { useSelector } from 'react-redux'
import { BotFeatures } from '@feedyou/schema'

import { RootState } from '../../../reducers'

import { sdkFeatureSelector } from '../selectors/sdkFeatureSelector'

export function useSdkFeature(featureName: BotFeatures) {
  // @ts-ignore
  return useSelector<RootState, boolean>(state => sdkFeatureSelector(state, featureName))
}
